import axios from '@/axios';

export default {
  methods: {
    downloadConfirm(params) {
      const { documentGuid } = params;
      if (documentGuid.length === 0) {
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadNoItemsSelectedMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });

        return;
      }
      this.$vs.dialog({
        type: 'confirm',
        title: this.$t('ConfirmDownload'),
        text: this.$t('ConfirmDownloadMessage'),
        accept: () => this.multiDownload(params),
        acceptText: this.$t('Download'),
      });
    },
    async getDownloadAllFile(fileParams) {
      this.showDownloadPopup = true;
      this.downloadingAll = true;
      try {
        this.downloadFile = await this.getAllFilesDownloadInfo(fileParams);
        this.downloadAllSuccess = true;

      } catch (e) {
        console.log(e);
        this.downloadAllSuccess = false;
      }

      this.downloadingAll = false;
    },
    async downloadAll(file) {
      this.showDownloadPopup = true;

      try {
        await this.getAllFiles(file)
      } catch (e) {
        console.log(e);
        this.downloadAllSuccess = false;
      }
    },
    async getAllFiles(file) {
      console.log(file);
      try {
        const { data } = await axios.get(file.DocumentDownloadUrl,  { responseType: 'arraybuffer' });
        const blob = new Blob([data], { type: this.getFileType(file.Extension) })

        // This should not be needed and should be removed once their API is sorted
        const FriendlyName = file.FriendlyName || 'tempName';

        const filename = `${FriendlyName}.${file.Extension}`;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (e) {
        this.downloadAllSuccess = false;
        console.log(e);
      }
    },
    async getDownloadInfo(params) {
      try {
        const data = await this.$api.report.getReportTypes(params);

        return data.data;
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadFileFailureMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    async getAllFilesDownloadInfo(fileParams) {
      const { data } = await this.$api.report.getReportTypes(fileParams);

      return data.data;
    },
    formatGuidsForApi(guids) {
      let data = {};
      for (const key in guids) {
        data['documentGuid[' + key + ']'] = guids[key];
      }

      return data;
    },
    getFileType(extension) {
      let fileType;
      switch (extension) {

        default:
          fileType = 'application/' + extension;
          break;
      }

      return fileType;
    }
  },
};
